
/* eslint-disable no-console */
import { defineComponent } from 'vue'
import Container from './Container.vue'
import addBranchSlugToUrl from '@/helper/addBranchSlugToUrl'
import useStore from './../store'
import { ICategory, IButtonLink, ISubmenuLink, IBottomLinkGroupList } from './../type'

const store = useStore(window.pinia)

export default defineComponent({
    props: ['activeCategory'],
    data () {
        return {
            links: {
                button: [] as IButtonLink[],
                submenu: [] as ISubmenuLink[],
                bottom: {} as IBottomLinkGroupList,
            },
        }
    },
    computed: {
        isOpen (): boolean {
            return store.isOpen()
        },
        sections (): ICategory[] {
            return store.getSections()
        },
        storeTitle () {
            return window.config.getBranchSlug()
        },
        domain () {
            return window.config.getDomain() ?? ''
        },
    },
    created () {
        const links = sessionStorage.getItem('megamenu-links')
        if (links !== null) {
            this.links = JSON.parse(links)
            return
        }

        fetch(this.domain + '/ajax/megamenu-links')
            .then(response => response.json())
            .then(payload => {
                this.links = payload
                sessionStorage.setItem('megamenu-links', JSON.stringify(payload))
            })
            .catch(error => {
                console.error(error)
            })
    },
    methods: {
        addStoreToUrl: addBranchSlugToUrl,
        mouseenter (category: ICategory) {
            // If screen more than 980px.
            if (window.matchMedia('(min-width: 981px)').matches) {
                store.openCategory(category)
            }
        },
        mouseleave (event: MouseEvent) {
            // If screen more than 980px.
            // je to jenom, když přejedeš myší z megamenu do submenu (akce, témata, události, ... ).. hlavní close je v App.vue:2
            if (window.matchMedia('(min-width: 981px)').matches
                && event.relatedTarget === this.$refs.submenu) {
                store.close()
            }
        },
        click (category: ICategory, event: MouseEvent) {
            const element = event.currentTarget as HTMLAnchorElement
            // If screen eq or less than 980px
            if (window.matchMedia('(max-width: 980px)').matches) {
                event.preventDefault()
                setTimeout(() => {
                    const yCoordinate = element.getBoundingClientRect().top + window.pageYOffset
                    const yOffset = -100
                    window.scrollTo({
                        top: yCoordinate + yOffset,
                        behavior: 'smooth',
                    })
                }, 200)
                store.toggleCategory(category)
            }

            // else redirect
            // If <a> has no .active class do nothing. Mouseenter it does.
            // On other hand let it flow and redirect will happned.
            if (!element.classList.contains('active')) {
                event.preventDefault()
            }
        },
    },
    components: {
        Container,
    },
})
